/* eslint-disable */
import { messageTableConstants } from '../constants/messageTableConstants';

export function messageTableGet(state = {}, action) {
    switch (action.type) {
        case messageTableConstants.MESSAGE_TABLE_REQUEST:
            return {
                ...state,
                request: true,
                success: false,
                error: false
            };
        case messageTableConstants.MESSAGE_TABLE_SUCCESS:
            return {
                ...state,
                request: false,
                success: true,
                error: false,
                [action.slug]: action.data
            };
        case messageTableConstants.MESSAGE_TABLE_ERROR:
            return {
                ...state,
                request: false,
                success: false,
                error: true
            };
        default:
            return state;
    }
}

export function messageTablePost(state = {}, action) {
    switch (action.type) {
        case messageTableConstants.MESSAGE_TABLE_POST_REQUEST:
            return {
                ...state,
                request: true,
                success: false,
                error: false,
                status: null,
                callback: null
            };
        case messageTableConstants.MESSAGE_TABLE_POST_SUCCESS:
            return {
                ...state,
                request: false,
                success: true,
                error: false,
                status: null,
                [action.slug]: action.data,
                callback: action.callback
            };
        case messageTableConstants.MESSAGE_TABLE_POST_ERROR:
            return {
                ...state,
                request: false,
                success: false,
                error: true,
                status: action.status,
                callback: action.callback
            };
        case messageTableConstants.MESSAGE_TABLE_POST_RESET:
            return {};
        default:
            return state;
    }
}
